import React from "react";
import "../styles/BodPage.css";
import GorakhMahadik from "../assets/photos/gorakh-mahadik.png";
import HemantNimbalkar from "../assets/photos/hemant-nimbalkar.png";
import AshokPhalke from "../assets/photos/ashok-phalke.png";
import VasantGhadge from "../assets/photos/vasant-ghadge.png";
import ArvindSalunkhe from "../assets/photos/arvind-salunkhe.png";
import AmitChavan from "../assets/photos/amit-chavan.png";
import RamdasChavan from "../assets/photos/ramdas-chavan.png";
import NitinPisal from "../assets/photos/nitin-pisal.png";
import SantoshDhumal from "../assets/photos/santosh-dhumal.png";
import VijayShelar from "../assets/photos/vijay-shelar.png";
import SanjeevaniJadhav from "../assets/photos/sanjeevani-jadhav.png";
import MohiniDeshmukh from "../assets/photos/mohini-deshmukh.png";
import PandurangGosavi from "../assets/photos/pandurang-gosavi.png";
import SampatRaste from "../assets/photos/sampat-raste.png";
import ShaukatMOmin from "../assets/photos/shaukat-momin.png";
import HanmantJadhav from "../assets/photos/hanmant-jadhav.png";
import JitendraAarte from "../assets/photos/jitendra-aarte.png";
import MadusudanPai from "../assets/photos/madusudan-pai.png";






// ══════════════════════════════════════════════════════
// HOW TO ADD PHOTOS WHEN READY:
// 1. Put photos in: src/assets/photos/bod/
// 2. Import at top: import ChairmanImg from "../assets/photos/bod/chairman.jpg";
// 3. Replace placeholder={true} with src={ChairmanImg}
// ══════════════════════════════════════════════════════

const CHAIRMAN = {
  name: "Mr. Ramdas T. Chavan",
  role: "Hon'ble Chairman",
  src:RamdasChavan,
};

const VICE_CHAIRMAN = {
  name: "Mr. Gorakh R. Mahadik",
  role: "Hon'ble Vice Chairman",
  src: GorakhMahadik,
};

const DIRECTORS = [
  { name: "Mr. Ashok A. Phalke", role: "Director", src:AshokPhalke },
  { name: "Mr. Vasant V. Ghadge", role: "Director", src:VasantGhadge },
  { name: "Mr. Hemant A. Nimbalkar", role: "Director", src:HemantNimbalkar },
  { name: "Mr. Arvind G. Salunkhe", role: "Director", src:ArvindSalunkhe },
  { name: "Mr. Santosh S. Dhumal", role: "Director", src:SantoshDhumal },
  { name: "Mr. Vijay T. Shelar", role: "Director", src:VijayShelar },
  { name: "Mrs. Sanjeevani B. Jadhav", role: "Director", src:SanjeevaniJadhav},
  { name: "Mrs. Mohini M. Deshmukh", role: "Director", src:MohiniDeshmukh },
  { name: "Mr. Sampat U. Raste", role: "Director", src:SampatRaste },
  { name: "Mr. Shaukat M. Momin", role: "Director", src:ShaukatMOmin },
  { name: "Mr. Pandurang D. Gosavi", role: "Director", src:PandurangGosavi },
];

const EXPERT_DIRECTORS = [
  { name: "Mr. Amit L. Chavan", role: "Expert Director", src:AmitChavan },
  { name: "Mr. Nitin H. Pisal", role: "Expert Director", src:NitinPisal },
];

const STAFF_REPS = [
  { name: "Mr. Jitendra B. Aarte", role: "Staff Representative", src:JitendraAarte },
  { name: "Mr. Hanmant K. Jadhav", role: "Staff Representative", src:HanmantJadhav },

];

const CEO = {
  name: "Dr. Madhusudan D. Pai",
  role: "Chief Executive Officer",
  src:MadusudanPai,
};

function BodCard({ member, size = "normal" }) {
  return (
    <div className={`bodpage-card bodpage-card--${size}`}>
      <div className="bodpage-card-photo">
        {member.placeholder ? (
          <div
            className="bodpage-photo-placeholder"
            style={{ background: `linear-gradient(135deg, ${member.color}, #27a3d7)` }}
          >
            <span>{member.initials}</span>
            <small>Add Photo</small>
          </div>
        ) : (
          <img src={member.src} alt={member.name} className="bodpage-photo-img" />
        )}
      </div>
      <div className="bodpage-card-info">
        <div className="bodpage-card-name">{member.name}</div>
        <div className="bodpage-card-role">{member.role}</div>
        <div className="bodpage-card-divider" />
      </div>
    </div>
  );
}

export default function BodPage() {
  return (
    <div className="bodpage">

      {/* ── HERO ── */}
      <section className="bodpage-hero">
        <h1 className="bodpage-hero-title">Board of Directors</h1>
        <p className="bodpage-hero-sub">The Pillars of Our Bank</p>
      </section>

      {/* ── CHAIRMAN + VICE CHAIRMAN ── */}
      <section className="bodpage-top-sec">
        <BodCard member={CHAIRMAN} size="large" />
        <BodCard member={VICE_CHAIRMAN} size="large" />
      </section>

      {/* ── DIRECTORS ── */}
      <section className="bodpage-section">
        <div className="bodpage-sec-head">
          <div className="bodpage-sec-label">Board Members</div>
          <h2 className="bodpage-sec-title">Hon'ble Directors</h2>
        </div>
        <div className="bodpage-grid bodpage-grid--4">
          {[...DIRECTORS].map((m, i) => (
            <BodCard key={i} member={m} size="normal" />
          ))}
        </div>
      </section>

      <section className="bodpage-section">
              <div className="bodpage-sec-head">
                <div className="bodpage-sec-label">Board Members</div>
                <h2 className="bodpage-sec-title">Hon'ble Expert Directors</h2>
              </div>
              <div className="bodpage-grid bodpage-grid--4">
                {[...EXPERT_DIRECTORS].map((m, i) => (
                  <BodCard key={i} member={m} size="normal" />
                ))}
              </div>
            </section>

      {/* ── EXPERT DIRECTORS + STAFF REPS ── */}
      <section className="bodpage-section bodpage-section--alt">
        <div className="bodpage-sec-head">
          <div className="bodpage-sec-label">Appointed Members</div>
          <h2 className="bodpage-sec-title">Staff Representatives</h2>
        </div>
        <div className="bodpage-grid bodpage-grid--4">
          {STAFF_REPS.map((m, i) => (
            <BodCard key={i} member={m} size="normal" />
          ))}
        </div>
      </section>

      {/* ── CEO ── */}
      <section className="bodpage-section">
        <div className="bodpage-sec-head">
          <div className="bodpage-sec-label">Management</div>
          <h2 className="bodpage-sec-title">Chief Executive Officer</h2>
        </div>
        <div className="bodpage-ceo-wrap">
          <BodCard member={CEO} size="large" />
        </div>
      </section>

    </div>
  );
}